import BackButton from "../../components/BackButton";

export default function LegalStuff() {
  return (
    <div>
      <BackButton goBackRoute="/settings" title="Legal Stuff" />
    </div>
  );
}
